import { put, call } from "redux-saga/effects";
import { loginConstants } from "../actions/constants/loginConstants";
import { LoginService } from "../services/api/loginService";
import { exceptionHandler } from "../pages/common/functions";

function* loginGetDetail(request: any) {
	try {
		const result = yield call(LoginService.loginGetDetail, request.input);
		const res = exceptionHandler(result)
		if (!res.status) {
			yield put({ type: loginConstants.LoginGetDetailFailure, payload: "Login Failed! please check username and password." });
		}
		else {
			var info = res.data.user;		
			if (info === null) {
				yield put({ type: loginConstants.LoginGetDetailFailure, payload: "Login Failed! please check username and password." });
			}
			else {
				if (info.userId > 0) {
					yield put({
						type: loginConstants.LoginGetDetailSuccess,
						payload: res.data
					});
				}
				else {
					yield put({ type: loginConstants.LoginGetDetailFailure, payload: "Login Failed! please check username and password." });
				}
			}
		}

	} catch (e) {
		yield put({ type: loginConstants.LoginGetDetailFailure, payload: e });
	}
}

function* logoutGetDetail() {
	try {
		const result = yield call(LoginService.logoutGetDetail);
		const res = exceptionHandler(result)
		yield put({
			type: loginConstants.LogoutGetDetailSuccess,
			payload: res.data
		});
	} catch (e) {
		yield put({ type: loginConstants.LogoutGetDetailFailure, payload: e });
	}
}

function* forgotPasswordRequest(input: any) {
	try {
		const result = yield call(LoginService.forgotPasswordRequest, input.input);
		if (result.data.isSuccess) {
			yield put({
				type: loginConstants.ForgotPasswordSuccess,
				payload: result.data
			});
		} else {			
			yield put({ type: loginConstants.ForgotPasswordFailure, payload: result.data.status });
		}		
	} catch (e) {
		yield put({ type: loginConstants.ForgotPasswordFailure, payload: e });
	}
}

function* forgotPasswordCheckToken(input: any) {
	try {
		const result = yield call(LoginService.forgotPasswordCheckToken, input.token);
		if (result.data.isSuccess)
		{
			yield put({
				type: loginConstants.ForgotPasswordCheckTokenSuccess,
				payload: result.data
			});
		}
		else
		{
			yield put({ type: loginConstants.ForgotPasswordCheckTokenFailure, payload: result.data.status });
		}	
	} catch (e) {
		yield put({ type: loginConstants.ForgotPasswordCheckTokenFailure, payload: e });
	}
}

function* forgotPasswordReset(request: any) {
	try {
		const result = yield call(LoginService.forgotPasswordReset, request.input);
		if (result.data.isSuccess) {
			yield put({
				type: loginConstants.ForgotPasswordChangeSuccess,
				payload: result.data,
			});
		} else {
			yield put({ type: loginConstants.ForgotPasswordChangeFailure, payload: result.data.status });
		}		
	} catch (e) {
		yield put({ type: loginConstants.ForgotPasswordChangeFailure, payload: e });
	}
}

function* getUserByRefreshToken(input: any) {	
	try {
		const result = yield call(LoginService.getUserByRefreshToken, input.token);
		if (result.data.isSuccess) {
			yield put({
				type: loginConstants.GetUserByRefreshTokenSuccess,
				payload: result.data
			});
		} else {
			yield put({ type: loginConstants.GetUserByRefreshTokenFailure, payload: result.data });
		}		
	} catch (e) {
		yield put({ type: loginConstants.GetUserByRefreshTokenFailure, payload: e });
	}
}

function* frontAppCheckToken(input: any) {
	try {
		const result = yield call(LoginService.frontAppCheckToken, input.token);
		if (result.data.isSuccess) {
			yield put({
				type: loginConstants.FrontAppCheckTokenSuccess,
				payload: result.data
			});
		}
		else {
			yield put({ type: loginConstants.FrontAppCheckTokenFailure, payload: result.data.status });
		}
	} catch (e) {
		yield put({ type: loginConstants.FrontAppCheckTokenFailure, payload: e });
	}
}

export const loginSaga = {
	loginGetDetail,
	logoutGetDetail,
	forgotPasswordRequest,
	forgotPasswordCheckToken,
	forgotPasswordReset,
	frontAppCheckToken,	
	getUserByRefreshToken

}